var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({key:_vm.nSrc,attrs:{"src":_vm.nSrc}},'img',_vm.nAttrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }